import { render, staticRenderFns } from "./organizationlistteam.vue?vue&type=template&id=25d4edc6"
import script from "./organizationlistteam.vue?vue&type=script&lang=js"
export * from "./organizationlistteam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports